export default __webpack_public_path__ + "static/media/06_blue.978d1ac6.jpg";